export const TAB_ACTION = {
    show: 'show',
    preventChange: 'preventChange',
    allowChange: 'allowChange',
    resetActive: 'resetActive'
}
